<template>
  <transition name="fade">
    <div class="loading-box" v-if="loadingCounter">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="loading" />
        <div class="loading-text" v-if="loadingText">{{ loadingText }}</div>
      </Spin>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      loadingCounter: 0,
      loadingText: ''
    }
  },
  created () {
    this.initLoading()
  },
  methods: {
    initLoading () {
      window.showLoading = (text = '载入中...') => {
        this.loadingText = text
        this.loadingCounter++
      }
      window.hideLoading = force => {
        if (!this.loadingCounter) return
        if (force) this.loadingCounter = 0
        else this.loadingCounter--
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loading-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  background: rgba(255, 255, 255, .6);
  z-index: 10000;
}
.loading{
  animation: global-loading .6s linear infinite;

  &-text {
    margin-top: 1em;
  }
}
@keyframes global-loading {
  from { transform: rotate(0deg); }
  50%  { transform: rotate(180deg); }
  to   { transform: rotate(360deg); }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
